import { useNavigate } from 'react-router-dom';

import { CollectionComponentTypeForm } from '../components/CollectionComponentTypeForm';

export const EditCollectionComponentTypesCollectionComponentTypePage = () => {
  const navigate = useNavigate();

  return (
    <div className="p-10">
      <div>
        <CollectionComponentTypeForm
          type="Edit"
          onSubmit={async (collectionComponentTypeId) => {
            navigate(`/collection-component-types`);
          }}
          onCancel={() => {
            navigate(`/collection-component-types`);
          }}
        />
      </div>
    </div>
  );
};
